import Vue from 'vue';
import Vuex from 'vuex';
import constant from '../mixins/const';
import pinModule from './modules/pin';
import accountModule from './modules/account';
import errorModule from './modules/error';
import walletModule from './modules/wallet';
import newsModule from './modules/news';
import readQrModule from './modules/readQr';
import transferModule from './modules/transfer';
import worksModule from './modules/works';
import {currencyData} from "@/mixins/interface";

const dbName = 'virtual_wallet';
const version = 2;
const settingStoreName = 'settings';
const currencyAccountStoreName = 'currencyAccounts';
const newsStoreName = 'news';
const btcAddressStoreName = 'btcAddress';
const unconfirmedTxStoreName = 'unconfirmedTx';
const addresseeListName = 'addresseeList';
const feeBaseStoreName = 'feeBases';
const activeHistoryStore = 'activeHistories';
// const tokenStatusStoreName = 'tokenStatus';
// const pinStoreName = 'pins';
const storeDataArray = [
    {
        storeName: settingStoreName,
        key: 'optKey',
        autoIncrement: false,
        index: [
            {
                name: 'optKey',
                idx: 'optKey',
                unique: true,
                multiEntry: false
            }
        ]
    },
    {
        storeName: currencyAccountStoreName,
        key: 'name',
        autoIncrement: false,
        index: [
            {
                name: 'name',
                idx: 'name',
                unique: true,
                multiEntry: false
            },
            {
                name: 'platformAndAccountNumber',
                idx: ['platform', 'accountNumber'],
                unique: true,
                multiEntry: false
            },
            {
                name: 'platformAndAddress',
                idx: ['platform', 'address'],
                unique: false,
                multiEntry: false
            },
            {
                name: 'contractAndAddress',
                idx: ['contractAddress', 'address'],
                unique: false,
                multiEntry: false
            },
        ]
    },
    {
        storeName: newsStoreName,
        key: 'id',
        autoIncrement: false,
        index: [
            {
                name: 'id',
                idx: 'id',
                unique: true,
                multiEntry: false
            }
        ]
    },
    {
        storeName: btcAddressStoreName,
        key: ['accountNumber', 'privIdx', 'change'],
        autoIncrement: false,
        index: [
            {
                name: 'accountNumber',
                idx: 'accountNumber',
                unique: false,
                multiEntry: false
            },
            {
                name: 'privIdx',
                idx: 'privIdx',
                unique: false,
                multiEntry: false
            },
            {
                name: 'change',
                idx: 'change',
                unique: false,
                multiEntry: false
            },
            {
                name: 'payableAddresses',
                idx: ['accountNumber', 'amount'],
                unique: false,
                multiEntry: false
            },
        ]
    },
    {
        storeName: unconfirmedTxStoreName,
        key: ['name', 'txid'],
        autoIncrement: false,
        index: [
            {
                name: 'name',
                idx: 'name',
                unique: false,
                multiEntry: false
            },
            {
                name: 'address',
                idx: 'address',
                unique: false,
                multiEntry: false
            }
        ]
    },
    {
        storeName: feeBaseStoreName,
        key: 'basePlatform',
        autoIncrement: false,
        index: [
            {
                name: 'basePlatform',
                idx: 'basePlatform',
                unique: true,
                multiEntry: false
            }
        ]
    },
    {
        storeName: activeHistoryStore,
        key: ['name', 'hash'],
        autoIncrement: false,
        index: [
            {
                name: 'name',
                idx: 'name',
                unique: false,
                multiEntry: false
            },
            {
                name: 'nameBlock',
                idx: ['name', 'block'],
                unique: false,
                multiEntry: false
            },
            {
                name: 'sending',
                idx: ['name', 'movement'],
                unique: false,
                multiEntry: false
            }
        ]
    }

    // {
    //     storeName: tokenStatusStoreName,
    //     key: 'name',
    //     autoIncrement: false,
    //     index: [
    //         {
    //             name: 'name',
    //             unique: true
    //         }
    //     ]
    // },
    // {
    //     storeName: pinStoreName,
    //     key: 'id',
    //     autoIncrement: true,
    //     index: [
    //         {
    //             name: 'id',
    //             unique: true
    //         }
    //     ]
    // },
];


Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        router: null, // routerのオブジェクト
        vwIdb: null, // indexeddbのevent.resultを入れる
        currencyList: [], // 現在デバイスに保存されているアカウント一覧
        tokenIndexInitSwitch: false,
        pageBackFlg: false,
        footerBarFlg: true,
        modalData: {
            loadingModal: true,
        },
        created: null, // ウォレットを作成した時間
        newsState: null, // 受信したお知らせを保管。既読状態のリアルタイム取得に利用
        timezone: '',
        country: '',
        lang: 'ja'
    },
    getters: {
        getRouter(state: any) {
            return state.router;
        },
        getVwIdb(state: any) {
            return state.vwIdb;
        },
        getCurrencyList(state: any) {
            return state.currencyList;
        },
        getTokenIndexInitSwitch(state: any) {
            return state.tokenIndexInitSwitch;
        },
        getPageBackFlg(state: any) {
            return state.pageBackFlg;
        },
        getFooterBarFlg(state: any) {
            return state.footerBarFlg;
        },
        getModalData(state: any) {
            return state.modalData;
        },
        getCreated(state: any) {
            return state.created;
        },
        getNewsList(state: any) {
            return state.newsState;
        },
        getTimezone(state: any) {
            return state.timezone;
        },
        getCountry(state: any) {
            return state.country;
        },
        getLang(state: any) {
            return state.lang;
        }
    },
    actions: {
        setRouter(store: any, router: any) {
            store.commit('setRouter', router);
        },
        async setCurrencyList(store: any, currencyList: currencyData[]) {
            store.commit('setCurrencyList', currencyList);
            return;
        },
        async setCurrencyListProps(store: any, payload: any) {
            const currencyData = await store.dispatch('idbSelect', {stateName: null, storeName: 'currencyAccounts', keyValue: payload.name});
            store.commit('setCurrencyListProps', {
                currencyData: currencyData,
                name: payload.name,
                key: payload.key
            });
            return;
        },
        setTokenIndexInitSwitch(store: any, trigger: boolean) {
            store.commit('setTokenIndexInitSwitch', trigger);
        },
        async setTimezone(store: any, timezone: string) {
            store.commit('setTimezone', timezone);
            return;
        },
        async setCountry(store: any, country: string) {
            store.commit('setCountry', country);
            return;
        },
        async setLang(store: any, lang: string) {
            store.commit('setLang', lang);
        },

        initDB(store: any) {
            return new Promise((resolve, reject) => {
                // store.commit('initDB', store);
                if (!window.indexedDB) {
                    window.alert("このブラウザーは安定版の IndexedDB をサポートしていません。IndexedDB の機能は利用できません。");
                    return;
                }
                // const dbp = new Promise((resolve, reject) => {
                const idbOpenReq = indexedDB.open(dbName, version);

                // versionが前回より大きくなった場合のみ動く
                idbOpenReq.onupgradeneeded = async function(event: any) {
                    let vwIdb = event.target.result;
                    console.log('vwIdb', vwIdb);
                    let idbTempData: any = {};
                    if (event.oldVersion > 0) {
                        // 更新時のみ一旦現在のデータを保持する
                        const idbTempGet = async function() {
                            const idbOpenOldReq = indexedDB.open(dbName, event.oldVersion);

                            idbOpenOldReq.onsuccess = async function(e: any) {
                                console.log('db open success');
                                return e.target.result;
                            }
                            // DB接続失敗時
                            idbOpenOldReq.onerror = function(e: any) {
                                // 接続に失敗
                                console.log('db open error',e);
                                return null;
                            }
                        }
                        const getAll = async function(storeName: string, idbTemp: any) {
                            const trans = idbTemp.transaction(storeName, 'readonly');
                            const obj = trans.objectStore(storeName);
                            const getReq = obj.getAll();

                            getReq.onsuccess = function(event: any) {
                                console.log('idbSelectAll success', event.target.result);
                                return event.target.result;
                            }

                            getReq.onerror = function(e: any) {
                                console.error('idbSelectAll err', e);
                                return null;
                            }
                        }
                        const idbTemp: any = await idbTempGet();
                        console.log('idbTemp', idbTemp);


                        const storeNames: string[] = Array.from(idbTemp.objectStoreNames);
                        for (let i = 0; i < storeNames.length; i++) {
                            const storeName: string = storeNames[i];
                            const storeData = await getAll(storeName, idbTemp)
                            idbTempData[storeName] = storeData;
                        }
                    }
                    if (event.oldVersion == 0 || idbTempData.length > 0) {

                        for (let i = 0; i < storeDataArray.length; i++) {
                            const storeData = storeDataArray[i];

                            // 未作成のstoreの場合
                            let storeCreated = null;
                            if (storeData.key == null) {
                                storeCreated = vwIdb.createObjectStore(storeData.storeName);
                            } else {
                                if (typeof storeData.key === 'object') {
                                    let keyArray = [];
                                    for (let j = 0; j < storeData.key.length; j++) {
                                        keyArray.push(storeData.key[j])
                                    }
                                    storeCreated = vwIdb.createObjectStore(storeData.storeName, {
                                        keyPath: keyArray,
                                        autoIncrement: storeData.autoIncrement
                                    });
                                } else {
                                    storeCreated = vwIdb.createObjectStore(storeData.storeName, {
                                        keyPath: storeData.key,
                                        autoIncrement: storeData.autoIncrement
                                    });
                                }

                            }
                            if (storeData.index.length > 0) {
                                // 検索するためのインデックスを作成
                                for (let j = 0; j < storeData.index.length; j++) {
                                    const indexName = storeData.index[j].name;
                                    const index = storeData.index[j].idx;
                                    const indexUnique = storeData.index[j].unique;
                                    const indexMultiEntry = storeData.index[j].multiEntry;
                                    storeCreated.createIndex(indexName, index, {
                                        unique: indexUnique,
                                        multiEntry: indexMultiEntry
                                    });
                                }
                            }
                            console.warn(storeData.storeName+'テーブルを作成しました')
                        }
                    }

                    const addData = function(storeName: string, data: any, vwIdb: any) {
                        return new Promise((resolve, reject) => {
                            const trans = vwIdb.transaction(storeName, 'readwrite');
                            const obj = trans.objectStore(storeName);
                            const addReq = obj.add(data);

                            addReq.onsuccess = function() {
                                console.log('idbAdd copy success', data);
                                resolve(data);
                            }
                            addReq.onerror = function(e: any) {
                                console.error('idbAdd copy err', e);
                                reject(false);
                            }
                        });
                    }

                    if (idbTempData.length > 0) {
                        for(let storeName in idbTempData) {
                            const dataList = idbTempData[storeName];
                            for (let i = 0; i < dataList.length; i++) {
                                await addData(storeName, dataList[i], vwIdb);
                            }
                        }
                    }
                }
                // DB接続成功時
                idbOpenReq.onsuccess = async function(event: any) {
                    //onupgradeneededの後に実行。更新がない場合はこれだけ実行
                    store.commit('setIDB', event.target.result);
                    console.log('db open success');
                    resolve(true);
                }
                // DB接続失敗時
                idbOpenReq.onerror = function(e:any) {
                    // 接続に失敗
                    console.log('db open error',e);
                    reject('cannot connect db');
                }
            });

        },

        getPageInfo(store: any, pageName: string) {
            return new Promise((resolve, reject) => {
                // ページ情報を取得
                console.log('constant.pageInfo', constant.pageInfo);
                let res = null;
                res = constant.pageInfo.filter(function(item, index){
                    if (item.name == pageName) {
                        return true;
                    }
                });
                console.log('filtered:', res);
                if (res.length > 0) {
                    resolve(res[0]);
                } else {
                    reject(null);
                }
            });
        },
        pageBackControl(store: any, bool: boolean) {
            return new Promise((resolve) => {
                store.commit('setState', {stateName: 'pageBackFlg', data: bool});
                resolve(true);
            });
        },
        footerBarControl(store: any, bool: boolean) {
            store.commit('setState', {stateName: 'footerBarFlg', data: bool});
        },
        switchModal(store: any, data: {name: string, switch: boolean}) {
            const pushData = {
                key: data.name,
                value: data.switch
            }
            store.commit('pushState', {stateName: 'modalData', data: pushData});
        },
        replaceNewsState(store: any, data: any) {
            store.commit('replaceNewsState', data);
        },
        // Promiseで返すのでawaitやthenが可能
        /**
         * indexeddbに追加 options.stateNameが設定されている場合は該当のstateを上書きする
         * @param store object
         * @param options object
         */
        idbAdd(store: any, options: {stateName: string, storeName: string, data: any}) {
            // store.commit('idbAdd', options);
            function set(store: any, options: {stateName: string, storeName: string, data: any}) {
                return new Promise((resolve, reject) => {
                    const vwIdb = store.getters.getVwIdb;
                    if (!vwIdb) {
                        reject('indexeddb reading error');
                    } else {
                        const trans = vwIdb.transaction(options.storeName, 'readwrite');
                        const obj = trans.objectStore(options.storeName);
                        const addReq = obj.add(options.data);

                        addReq.onsuccess = function () {
                            console.log('idbAdd success', options.data);
                            resolve(options.data);
                        }
                        addReq.onerror = function (e: any) {
                            console.error('idbAdd err', e);
                            reject(false);
                        }
                    }
                });
            }
            return new Promise((resolve, reject) => {
                set(store, options).then(function(dbp) {
                    if (!dbp) {
                        reject('adding error');
                    } else {
                        if (options.stateName != null) {
                            store.commit('setState', {stateName: options.stateName, data: dbp});
                        }
                        resolve(true);
                    }
                })
                .catch((e: any) => {
                    console.error(e);
                    reject('idbAdd error');
                });
            });
        },
        // Promiseで返すのでawaitやthenが可能
        idbPut(store: any, options: {stateName: string, storeName: string, data: any}) {
            // store.commit('idbPut', options);
            function set(store: any, options: {stateName: string, storeName: string, data: any}) {
                return new Promise((resolve, reject) => {
                    const vwIdb = store.getters.getVwIdb;
                    if (!vwIdb) {
                        reject('indexeddb reading error');
                    } else {
                        const trans = vwIdb.transaction(options.storeName, 'readwrite');
                        const obj = trans.objectStore(options.storeName);
                        const addReq = obj.put(options.data);

                        addReq.onsuccess = function () {
                            console.log('idbPut success', options.data);
                            resolve(options.data);
                        }

                        addReq.onerror = function (e: any) {
                            console.error(e);
                            reject('idbPut err');
                        }
                    }
                });
            }
            return new Promise((resolve, reject) => {
                set(store, options)
                .then(function(dbp) {
                    if (options.stateName != null) {
                        store.commit('setState', {stateName: options.stateName, data: dbp});
                        console.log('setState', options.stateName);
                    }
                    resolve(true);
                })
                .catch((e: any) => {
                    console.error(e);
                    reject('idbPut');
                });
            });
        },
        // Promiseで返すのでawaitやthenが可能
        idbSelect(store: any, options: {stateName: string, storeName: string, keyValue: string}) {
            function set(store: any, options: {stateName: string, storeName: string, keyValue: string}) {
                return new Promise((resolve, reject) => {
                    const vwIdb = store.getters.getVwIdb;
                    if (!vwIdb) {
                        reject('indexeddb reading error');
                    } else {
                        const trans = vwIdb.transaction(options.storeName, 'readonly');
                        const obj = trans.objectStore(options.storeName);
                        const getReq = obj.get(options.keyValue);

                        getReq.onsuccess = function(event: any) {
                            console.log('idbSelect payloads', options);
                            console.log('idbSelect success', event.target.result);
                            let result = null;
                            if (event.target != undefined && event.target.result != undefined) {
                                result = event.target.result;
                            }
                            resolve(result);
                        }

                        getReq.onerror = function(e: any) {
                            console.error(e);
                            reject('idbSelect err');
                        }
                    }

                });
            }
            return new Promise((resolve, reject) => {
                set(store, options)
                .then(function(dbp) {
                    // もしstateが指定されていればsetする
                    if (options.stateName !== null) {
                        store.commit('setState', {stateName: options.stateName, data: dbp});
                    }
                    resolve(dbp);
                })
                .catch(function(e: any) {
                    console.error('idbSelect->set reject', e);
                    reject('idbSelect error');
                });
            });
        },
        idbGetByIdx(store: any, options: {stateName: string, storeName: string, indexName: string, search: any}) {
            function set(store: any, options: {stateName: string, storeName: string, indexName: any, search: any}) {
                return new Promise((resolve, reject) => {
                    const vwIdb = store.getters.getVwIdb;
                    if (!vwIdb) {
                        reject('indexeddb reading error');
                    } else {
                        const trans = vwIdb.transaction(options.storeName, 'readonly');
                        const obj = trans.objectStore(options.storeName);
                        const myIndex = obj.index(options.indexName);
                        // :TODO 取得できない場合に結局エラー起きるなら以下の流れ不要
                        // ↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓↓
                        const countReq = myIndex.count();
                        countReq.onsuccess = function (countEvent: any) {
                            const count = countEvent.target.result;
                            if (count == 0) {
                                resolve([]);
                            } else {
                                // ↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑↑
                                let range: any;
                                if (options.search.range) {
                                    range = IDBKeyRange.bound(options.search.range.lower, options.search.range.upper);
                                } else {
                                    range = options.search.value;
                                }
                                const getReq = myIndex.openCursor(range, "next");
                                const result: any = [];

                                getReq.onsuccess = function (event: any) {
                                    let cursor = null;
                                    if (event.target != undefined && event.target.result != undefined) {
                                        cursor = event.target.result;
                                    }
                                    if (cursor) {
                                        result.push(cursor.value);
                                        cursor.continue();
                                    } else {
                                        resolve(result);
                                    }
                                };

                                getReq.onerror = function (e: any) {
                                    console.error(e);
                                    reject('idbGetByIdx getReq');
                                }
                            }
                        }

                        countReq.onerror = function (e: any) {
                            console.error(e);
                            reject('idbGetByIdx countReq');
                        }
                    }
                });
            }
            return new Promise((resolve, reject) => {
                set(store, options)
                .then(function(dbp) {
                    // もしstateが指定されていればsetする
                    if (options.stateName !== null) {
                        store.commit('setState', {stateName: options.stateName, data: dbp});
                    }
                    resolve(dbp);
                })
                .catch((e: any) => {
                    console.error(e);
                    reject('idbGetByIdx');
                });
            });
        },
        // Promiseで返すのでawaitやthenが可能
        idbDelete(store: any, options: {stateName: string, storeName: string, keyValue: string}) {
            function set(store: any, options: {stateName: string, storeName: string, keyValue: string}) {
                return new Promise((resolve, reject) => {
                    const vwIdb = store.getters.getVwIdb;
                    if (!vwIdb) {
                        reject('indexeddb reading error');
                    } else {
                        const trans = vwIdb.transaction(options.storeName, 'readwrite');
                        const obj = trans.objectStore(options.storeName);
                        const getReq = obj.delete(options.keyValue);

                        getReq.onsuccess = function (event: any) {
                            console.log('idbDelete success', event.target.result);
                            resolve(true);
                        }

                        getReq.onerror = function (e: any) {
                            console.error(e);
                            reject('idbDelete err');
                        }
                    }
                });
            }
            return new Promise((resolve, reject) => {
                set(store, options).then(function(dbp) {
                    if (dbp) {
                        store.commit('setState', {stateName: options.stateName, data: null});
                    }
                    resolve(true);
                }).catch((e: any) => {
                    console.error(e);
                    reject('idbDelete');
                });
            });
        },
        idbSelectAll(store: any, options: {stateName: string, storeName: string}) {
            function set(store: any, options: {stateName: string, storeName: string}) {
                return new Promise((resolve, reject) => {
                    const idb = store.getters.getVwIdb;
                    if (!idb) {
                        reject(null);
                    } else {
                        const trans = idb.transaction(options.storeName, 'readonly');
                        const obj = trans.objectStore(options.storeName);
                        const getReq = obj.getAll();

                        getReq.onsuccess = function(event: any) {
                            console.log('idbSelectAll success', event.target.result);
                            let result = null;
                            if (event.target != undefined && event.target.result != undefined) {
                                result = event.target.result;
                            }
                            resolve(result);
                        }

                        getReq.onerror = function(e: any) {
                            console.error('idbSelectAll err', e);
                            reject(null);
                        }
                    }
                });
            }
            return new Promise((resolve,reject) => {
                set(store, options).then(function(dbp) {
                    if (options.stateName != null) {
                        store.commit('setState', {stateName: options.stateName, data: dbp});
                    }
                    resolve(dbp);
                }).catch((e: any) => {
                    console.error(e);
                    reject('idbSelectAll');
                });
            });
        },
        allIdbDelete(store: any) {
            function set() {
                return new Promise((resolve, reject) => {
                    // indexeddbを削除
                    const deleteReq = indexedDB.deleteDatabase(dbName);

                    deleteReq.onsuccess = function(){
                        console.log('db delete success');
                        resolve(true);
                    }

                    deleteReq.onerror = function(e: any){
                        console.log('db delete error', e);
                        reject(false);
                    }
                });
            }
            return new Promise(resolve => {
                set().then(function(dbp) {
                    if (dbp) {
                        // アカウントを管理するstate
                        for (const key in store) {
                            if (key == 'router' || key == 'vwIdb') return;
                            store.key = null;
                        }
                        resolve(true);
                    }
                });
            });
        },
    },
    mutations: {
        setRouter(state: any, router: any) {
            console.log('router set:', router);
            state.router = router;
        },
        setCurrencyList(state: any, currencyList: currencyData[]) {
            for (let i in currencyList) {
                const currencyData: currencyData = currencyList[i];
                Vue.set(state.currencyList, i, currencyData);
            }
        },
        setCurrencyListProps(state: any, payload: {currencyData: any, name: string, key: string}) {
            console.warn('CurrencyData VuexCommit', payload.name);
            const currencyData = payload.currencyData;
            const key = payload.key;
            for(let i in state.currencyList) {
                if (state.currencyList[i].name == payload.name) {
                    console.warn(state.currencyList[i][key], currencyData[key]);
                    // 名前が一致したらプロパティを更新
                    Vue.set(state.currencyList[i], key, currencyData[key]);
                }
            }
        },
        setTokenIndexInitSwitch(state: any, trigger: boolean) {
            state.tokenIndexInitSwitch = trigger;
        },
        setTimezone(state: any, timezone: string) {
            state.timezone = timezone;
        },
        setCountry(state: any, country: string) {
            state.country = country;
        },
        setLang(state: any, lang: string) {
            state.lang = lang;
        },

        setIDB(state: any, vwIdb: any) {
            state.vwIdb = vwIdb;
            console.log('db upgrade');
        },
        replaceNewsState(state: any, data: any) {
            state.newsState = data;
        },
        setState(state: any, options: {stateName: string, data: any}) {
            console.log('setState', options.stateName, options.data);
            state[options.stateName] = options.data;
        },
        pushState(state: any, options: {stateName: string, data: any}) {
            state[options.stateName][options.data.key] = options.data.value;
        },
    },
    modules: {
        pinModule,
        accountModule,
        errorModule,
        walletModule,
        newsModule,
        readQrModule,
        transferModule,
        worksModule,
    }
})
